import { render } from "./DemoProductsServicesView.vue?vue&type=template&id=6436d305&scoped=true"
import script from "./DemoProductsServicesView.vue?vue&type=script&lang=js"
export * from "./DemoProductsServicesView.vue?vue&type=script&lang=js"

import "./DemoProductsServicesView.vue?vue&type=style&index=0&id=6436d305&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6436d305"]])

export default __exports__